import React from "react";
import PropTypes from "prop-types";
import { vehicleMasterViewConstants } from "../../../../../Constant";
import StreamView from "../streamView/ViewStream";

const CameraControls = ({
    cameraId,
    showStream,
    onStreamStart,
    onStreamStop,
    onStreamRetry,
    onStreamError,
    streamError,
    cameraRestartResponse,
    sdCardFormatResponse,
    cameraRestart,
    sdCardFormat,
    onCameraRestart,
    onSDCardFormat,
}) => {
    const { messages, operations, buttonLabels } = vehicleMasterViewConstants;

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return "Never";
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const renderOperationCard = (
        title,
        statusResponse,
        isLoading,
        onClickHandler,
        buttonText,
        buttonClass = "control-btn-primary",
        timeLabel = "Last Operation Time"
    ) => {
        const isInProgress = statusResponse?.status === "IN_PROGRESS";
        const isDisabled = isLoading || isInProgress;

        return (
            <div className="control-card">
                <div className="control-card-content">
                    <div className="control-card-title">
                        {title}
                    </div>
                    <div className="control-card-subtitle">
                        Last {title} Status: {statusResponse?.status || "Unknown"}
                    </div>
                    {statusResponse?.message && (
                        <div className="control-card-subtitle">
                            {statusResponse.message}
                        </div>
                    )}
                    {statusResponse?.createdAt && (
                        <div className="control-card-subtitle">
                            {timeLabel}: {formatTimestamp(statusResponse.createdAt)}
                        </div>
                    )}
                </div>
                <button
                    className={`control-btn ${buttonClass} ${isDisabled ? "disabled" : ""}`}
                    onClick={onClickHandler}
                    disabled={isDisabled}
                    aria-busy={isDisabled}
                    aria-label={`${title} button`}
                >
                    {isLoading ? "Processing..." : buttonText}
                </button>
            </div>
        );
    };

    let streamButtonClass = "control-btn-primary";
    if (showStream && streamError) {
        streamButtonClass = "control-btn-secondary";
    } else if (showStream) {
        streamButtonClass = "control-btn-danger";
    }

    let streamButtonText = "Start";
    if (showStream && streamError) {
        streamButtonText = "Retry";
    } else if (showStream) {
        streamButtonText = "Stop";
    }

    return (
        <div className="col-sm-6">
            <div>
                {/* Live Stream Section */}
                <div className="stream-header">
                    <div className="stream-header-title">
                        {messages.liveStream}
                    </div>
                    <div className="stream-status-bar">
                        <button
                            className={`control-btn ${streamButtonClass}`}
                            onClick={() => {
                                if (showStream && streamError) {
                                    onStreamRetry();
                                } else if (showStream) {
                                    onStreamStop();
                                } else {
                                    onStreamStart();
                                }
                            }}
                            aria-label="Stream control button"
                        >
                            {streamButtonText}
                        </button>
                    </div>
                </div>

                {showStream && (
                    <div className="stream-box">
                        <StreamView
                            cameraId={cameraId}
                            isModal={false}
                            onError={onStreamError}
                        />
                    </div>
                )}

                {!showStream && (
                    <div className="stream-empty-state">
                        {messages.streamToggled}
                    </div>
                )}

                {/* Device Controls Section */}
                <div className="device-controls-section">
                    <div className="device-controls-heading">
                        {messages.deviceControls}
                    </div>

                    {renderOperationCard(
                        operations.cameraRestart,
                        cameraRestartResponse,
                        cameraRestart,
                        onCameraRestart,
                        buttonLabels.restart,
                        "control-btn-primary",
                        "Last restart Time"
                    )}
                </div>
            </div>
        </div>
    );
};

CameraControls.propTypes = {
    cameraId: PropTypes.string.isRequired,
    showStream: PropTypes.bool.isRequired,
    onStreamStart: PropTypes.func.isRequired,
    onStreamStop: PropTypes.func.isRequired,
    onStreamRetry: PropTypes.func.isRequired,
    onStreamError: PropTypes.func,
    streamError: PropTypes.bool,
    cameraRestartResponse: PropTypes.shape({
        status: PropTypes.string,
        message: PropTypes.string,
        updatedAt: PropTypes.string,
    }),
    sdCardFormatResponse: PropTypes.shape({
        status: PropTypes.string,
        message: PropTypes.string,
        updatedAt: PropTypes.string,
    }),
    cameraRestart: PropTypes.bool.isRequired,
    sdCardFormat: PropTypes.bool.isRequired,
    onCameraRestart: PropTypes.func.isRequired,
    onSDCardFormat: PropTypes.func.isRequired,
};

export default CameraControls;
